import { EventEmitter, Injectable, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Experience, AppStatus, Item, Ost, User, GisQureyResult } from '../models';
import { TranslateService } from '@ngx-translate/core';
import { Observer, fromEvent } from 'rxjs';
import { Observable } from 'rxjs';
import Event from 'ol/events/Event';

@Injectable()

export class AppInformationService {

    @Output() changeCurrentLanguage = new EventEmitter<string>();
    @Output() changeCurrentExperience = new EventEmitter<Experience>();
    @Output() changeCurrentItem = new EventEmitter<Item>();
    @Output() changeCurrentOst = new EventEmitter<Ost>();
    @Output() changeCurrentStatus = new EventEmitter<AppStatus>();
    @Output() newOst = new EventEmitter<GisQureyResult>();
    @Output() onlineStatus = new EventEmitter<boolean>();
    @Output() changeDevice = new EventEmitter<boolean>();
    @Output() changeDownloadMaps = new EventEmitter<number>();
    @Output() changeDownloadingMaps = new EventEmitter<number>();

    onlineEvent: Observable<Event>;
    offlineEvent: Observable<Event>;

    private currentLang: string = 'it';
    private currentExperience: Experience;
    private currentItem: Item;
    private currentOst: Ost;
    private currentAppStatus: AppStatus;
    private connectionStatus: boolean = navigator.onLine;
    private device: string;
    private loadingMaps = [];
    private map_legends = 'map_legends';

    constructor(
        private translateService: TranslateService
    ) {

        this.onlineEvent = fromEvent(window, "online");
        this.offlineEvent = fromEvent(window, "offline");

        // document.addEventListener("online", (e) => {
        //     this.changeOnlineStatus(true);
        //     console.log("online");
        // });

        // document.addEventListener("offline", (e) => {
        //     this.changeOnlineStatus(false);
        //     console.log("offline");
        // });

        this.onlineEvent.subscribe(e => {
            this.changeOnlineStatus(true);
            // console.log('Online...');
        });

        this.offlineEvent.subscribe(e => {
            this.changeOnlineStatus(false);
            // console.log('Offline...');
        })

    }
    /** si controlla se se c'è stata un'esperienza
     * @returns boolean
     */
    hasExperience(): boolean {
        return this.currentExperience !== null;
    }
    /**si controlla se c'è un oggetto
     * @returns boolean
     */
    hasItem(): boolean {
        return this.currentItem !== null;
    }

    /** si controlla se c'è un OST
     * @returns boolean
     */
    hasOSt(): boolean {
        return this.currentOst !== null;
    }
    /** si cambia la lingua di defaultcon il parametro passato
     * @param  {string} lang
     */
    changeDefaultLang(lang: string) {
        this.currentLang = lang;
        this.translateService.setDefaultLang(lang);
        this.translateService.use(lang);
        localStorage.setItem('locale', lang);
        this.changeCurrentLanguage.emit(lang);
    }
    /**
     * si richiede la lingua di default
     */
    getDefaultLang() {
        return this.currentLang;
    }
    /** si cambia l'esperienza selezionata attraverso il parametro
     * @param  {Experience|null} ex
     */
    changeSelectedExperience(ex: Experience | null) {
        this.currentExperience = ex;
        this.changeCurrentExperience.emit(ex);
        // console.log(this.currentExperience);
    }
    /**si cambia l'oggetto selezionato attraverso il parametro
     * @param  {Item|null} item
     */
    changeSelectedItem(item: Item | null) {
        this.currentItem = item;
        this.changeCurrentItem.emit(item);
    }
    /** si cambia l'OSt selezionato attraverso il parametro
     * @param  {Ost|null} ost
     */
    changeSelectedOst(ost: Ost | null) {
        this.currentOst = ost;
        this.changeCurrentOst.emit(ost);
    }
    /** si cambia lo stato dell'app attraverso il parametro
     * @param  {AppStatus} status
     */
    changeAppStatus(status: AppStatus) {
        this.currentAppStatus = status;
        this.changeCurrentStatus.emit(status);
    }
    /** si cambia OSt con un successivo OSt
     * @param  {GisQureyResult} ost
     */
    changeNewOst(ost: GisQureyResult) {
        this.newOst.next(ost);
    }
    /** si cambia lo status online con un parametro boolean
     * @param  {boolean} value
     */
    changeOnlineStatus(value: boolean) {
        this.connectionStatus = value;
        this.onlineStatus.next(value);
    }
    /**
     * si richiede lo stato della connessione corrente
     */
    getCurrentConnectionStatus() {
        return this.connectionStatus;
    }
    /**
     * si richiede lo stato dell'app corrente
     */
    getCurrentAppStatus() {
        return this.currentAppStatus;
    }
    /** si setta l'info del device con il valore passaro con il parametro
     * @param  {string} value
     */
    setDeviceInfo(value: string) {
        this.device = value;
    }
    /**
     * si ottengono le affermazioni del device
     */
    getDeviceInfo() {
        return this.device;
    }
    /**
     * controllare se chi richiede l'app è da mobile o meno
     */
    iAmMobile() {
        // console.log(this.device);
        return ((<any>window).cordova !== undefined);
        if (this.device != 'browser') {
            return true;
        } else {
            return false;
        }
    }
    /**
     * inoltra la mappa selezionata nell'elenco di quelle interessate dall'app
     */
    setLoadingMaps(id: number) {
        this.loadingMaps.push(id);
    }
    /**
     * controlla se sta caricando la mappa
     */
    checkLoadingMaps(id: number) {
        return this.loadingMaps.filter(element => element == id);
    }
    /**
     * controlla quali mappe sono caricate
     */
    getLoagingMaps() {
        return this.loadingMaps;
    }
    /**
     * rimuove la mappa selezionata
     */
    removeLoadingMaps(id: number) {
        this.loadingMaps = this.loadingMaps.filter(element => element != id);
        this.changeDownloadingMaps.emit(id);
    }

    downloadComplete(id:number){
        // console.log("emit: " + id);
        this.changeDownloadMaps.emit(id);
    }

    setMapLegends(data){
        localStorage.setItem(this.map_legends, JSON.stringify(data));
    }

    getMapLegend(){
        let locale = this.translateService.getDefaultLang();
        let legends = JSON.parse(localStorage.getItem(this.map_legends));
        let selected;
        if(legends){
            selected = legends.find(el => el.locale == locale);
        }
        return selected;
    }
}
